import { client } from '../';

const AdCampaignsQuery = `
  query($search: JSON!, $order: [String!], $page: Int!, $limit: Int!) {
    adCampaigns(
      search: $search
      order: $order
      page: $page
      limit: $limit
    ) {
      data {
        id, name, remoteId, remoteStatus, objectiveName
        adAccount { id, name, remoteId, remoteStatus }
        channel { id, name }
      }
      paging { totalCount, totalPages }
    }
  }
`;

export const queryAdCampaigns = async (variables, operationContext = {}) => {
  const { data, error } = await client
    .query(AdCampaignsQuery, variables, operationContext)
    .toPromise();
  if (error) {
    throw new Error(error);
  }

  return data.adCampaigns;
};
